import { FC, FormEvent } from 'react';
import { formOptions } from '@tanstack/react-form';
import { useAppForm } from '@new/common/hooks/form';

type PasswordFormFields = 'currentPassword' | 'newPassword' | 'confirmPassword';

const PASSWORD_FIELDS: { name: PasswordFormFields; label: string; placeholder: string }[] = [
  { name: 'currentPassword', label: 'Current Password', placeholder: 'Enter current password' },
  { name: 'newPassword', label: 'New Password', placeholder: 'Enter new password' },
  { name: 'confirmPassword', label: 'Confirm Password', placeholder: 'Confirm new password' },
];

const passwordFormOpts = formOptions({
  defaultValues: {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  },
});

export const PasswordSettingsForm: FC = () => {
  const form = useAppForm({
    ...passwordFormOpts,
    validators: {
      onSubmit: () => {
        return undefined;
      },
    },
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    form.handleSubmit();
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-5">
      {PASSWORD_FIELDS.map(({ name, label, placeholder }) => (
        <form.AppField
          key={name}
          name={name}
          children={(field) => <field.Password label={label} placeholder={placeholder} disabled />}
        />
      ))}

      <form.AppForm>
        <form.SubmitButton label="Save changes" />
      </form.AppForm>
    </form>
  );
};
